module.exports.USER_ONBOARDING = {
  SEE_WATCHERS_INBOX: 'see_watchers_inbox',
  ADD_DECISION_TO_NEW_FOLDER: 'add_decision_to_new_folder',
  DOMAIN_SELECTION_ONBOARDING: 'legal_domains',
  DOMAIN_SELECTION_SKIPPED: 'skip_legal_domains',
};
